module.exports = __webpack_public_path__ + "img/check-back.3af30bb8.png";